/**
 * Synthetic examples of the revision, trash and Recent routes (1.0b deliverables 17 and 18), set in
 * "The Drowned Lanterns", on the `EXAMPLE_IDS` entries whose states record them: Salt in the
 * Wells at body version 2 with its revision 1, Harbour Gossip (live), A Torn Ledger (trashed).
 */
import { docMetaFrom } from '../dto/documents.js';
import { EXAMPLE_IDS } from './example-ids.js';
import { EXAMPLE_NOW } from './examples.js';
import { EXAMPLE_TYPE_IDS, exampleDocument } from './examples-docs.js';
const salt = EXAMPLE_IDS.questSaltInTheWells.id;
/** Salt in the Wells' text as its revision 1 holds it. */
const SALT_BODY_AT_REVISION_1 = {
    type: 'doc',
    content: [
        {
            type: 'paragraph',
            content: [{ type: 'text', text: 'The wells of the Lantern Quarter taste of the sea.' }],
        },
    ],
};
/** Revision 1 of Salt in the Wells, as `docs.revisions` lists it. */
export const EXAMPLE_REVISION_SUMMARY = {
    revNo: 1,
    reason: 'manual',
    bodyVersion: 1,
    metaVersion: 1,
    title: 'Salt in the Wells',
    createdAt: EXAMPLE_NOW,
};
/** The same revision whole, as `docs.revision` answers it. */
export const EXAMPLE_REVISION = {
    ...EXAMPLE_REVISION_SUMMARY,
    documentId: salt,
    typeId: EXAMPLE_TYPE_IDS.quest,
    aliases: [],
    canonStatus: 'canon',
    body: SALT_BODY_AT_REVISION_1,
    bodySchemaVersion: 1,
    props: {},
};
/** Salt in the Wells after `docs.restore` brings back revision 1's text over body version 2. */
export const EXAMPLE_RESTORED_DOC = exampleDocument({
    id: salt,
    fid: 'SaltInTheWells01',
    typeId: EXAMPLE_TYPE_IDS.quest,
    typeKey: 'quest',
    title: 'Salt in the Wells',
    body: SALT_BODY_AT_REVISION_1,
    bodyVersion: 3,
});
const note = (id, fid, title, extra = {}) => docMetaFrom(exampleDocument({
    id,
    fid,
    typeId: EXAMPLE_TYPE_IDS.note,
    typeKey: 'note',
    title,
    body: { type: 'doc', content: [{ type: 'paragraph' }] },
    metaVersion: 2,
    ...extra,
}), { capabilities: [], homeId: null });
/** Harbour Gossip after `docs.trash`. */
export const EXAMPLE_TRASHED_META = note(EXAMPLE_IDS.noteHarbourGossip.id, 'HarbourGossip001', 'Harbour Gossip', { deletedAt: EXAMPLE_NOW });
/** A Torn Ledger after `docs.untrash`. */
export const EXAMPLE_UNTRASHED_META = note(EXAMPLE_IDS.noteTornLedger.id, 'TornLedgerNote01', 'A Torn Ledger');
/** The Trash as `p1a` holds it: A Torn Ledger (Lamplighter Notes is merged, so not listed). */
export const EXAMPLE_TRASH_ITEM = {
    id: EXAMPLE_IDS.noteTornLedger.id,
    fid: 'TornLedgerNote01',
    title: 'A Torn Ledger',
    typeKey: 'note',
    deletedAt: EXAMPLE_NOW,
};
//# sourceMappingURL=examples-history.js.map